import { imageUrls } from './taskResults';
import features from '../components/features';

export function historyTask(row, url = value => value || '') {
  const urls = imageUrls(row.result_url).map(url);
  let options = {};
  try { options = typeof row.function_option === 'string' ? JSON.parse(row.function_option) : row.function_option || {}; } catch {}
  const feature = features.find(f => f.id === row.function_name);
  return {
    id: `hist_${row.process_id}`, process_id: row.process_id, isGlobalHistory: true,
    feature: feature?.name || row.function_name || '작업', featureId: row.function_name,
    startTime: Date.parse(row.used_at) || 0, endTime: urls.length ? Date.parse(row.used_at) || 0 : null,
    status: row.process_status, completed: row.process_status === 'completed' || urls.length > 0,
    originalImage: url(row.original_url || options.original_url || options.upload_url || ''),
    resultImage: urls[0] || '', resultImages: urls.length > 1 ? urls : null, needsSelection: urls.length > 1,
    thumbnail: url(imageUrls(row.thumbnail_url)[0] || ''), options,
    coinCost: row.coin_cost, coinRefunded: Boolean(row.coin_refunded),
    backgroundUpscaleSupported: row.background_upscale_supported === true,
    editHistory: []
  };
}

export function mergeHistory(tasks, rows, url = value => value || '') {
  const byProcess = new Map(rows.map(row => [String(row.process_id), historyTask(row, url)]));
  const byResult = new Map([...byProcess.values()].filter(task => task.resultImage && !task.needsSelection).map(task => [task.resultImage, task]));
  const existingIds = new Set();
  const existingUrls = new Set();
  const result = tasks.map(task => {
    const server = byProcess.get(String(task.process_id)) || (!task.needsSelection && byResult.get(url(task.resultImage)));
    const merged = server ? { ...task, ...server, id: task.id, isGlobalHistory: task.isGlobalHistory,
      originalImage: server.originalImage || task.originalImage, editHistory: task.editHistory || [],
      options: { ...task.options, ...server.options } } : task;
    if (merged.process_id != null) existingIds.add(String(merged.process_id));
    [merged.resultImage, ...(merged.resultImages || []), ...(merged.editHistory || []).map(item => item.resultImage)]
      .filter(Boolean).forEach(value => existingUrls.add(url(value)));
    return merged;
  });
  for (const [id, task] of byProcess) {
    if (existingIds.has(id) || (task.resultImage && existingUrls.has(task.resultImage))) continue;
    existingIds.add(id); result.push(task);
  }
  const seen = new Set();
  return result.filter(task => { if (seen.has(String(task.id))) return false; seen.add(String(task.id)); return true; })
    .sort((a, b) => b.startTime - a.startTime);
}
